/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tc_CopyInputs */



/**
* | output |
* | --- |
* | "TC Copy" |
*
* @param {Tc_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tc_copy = /** @type {((inputs?: Tc_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tc_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copie de TC")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC-Kopie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia TC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("TC Copy")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copia de TC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("TC副本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TCコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीसी कॉपी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cópia TC")
	return /** @type {LocalizedString} */ ("TC Copy")
});